import React,{useState, useEffect, useMemo} from "react"
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
// import "../../css/bootstrap.min.css";
import "../../../css/font.css";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import {jobscategorycreate} from '../../../apis/urls'
import {schoolJobsurl} from '../../../apis/urls'
import DatePicker from "react-datepicker";
import moment from 'moment'
import { RichTextEditor } from '@mantine/rte';

const initialValue =
'<p></p>';

const AddJobComponent = () =>{



    useEffect(() => {
        Listing();
    },[]
    );

    const [result,setResult] = useState([]);
    const [title,setTitle] = useState('');
    const [description,setDescription] = useState(initialValue);
    const [expires_on,setExpires_on] = useState('');
    const [contact_name,setContact_name] = useState('');
    const [contact_email,setContact_email] = useState('');
    const [job_category_id,setJob_category_id] = useState('');
    const [status,setStatus] = useState('');


    const [titleerror,setTitleerror] = useState(false);
    const [expriresnerror,setExpriresnerror] = useState(false);
    const [jobcat,setJobcat] = useState(false);
    

   const descriprionset = (text) =>{
       //console.log(text)

       
       setDescription(text)
   }


    const { id } = useParams();
   
    let navigate = useNavigate();
    const RoutToList = (id) =>{

        let path = 'newPath'; 
        navigate("/jobs/"+id)
        
    }

    const Listing = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: jobscategorycreate+'?page='+0+'&size='+200,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setResult(response.data.data.items);
            //console.log(response.data.data)
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }

    const OnFormClick = (school_id) => {

        let error = 0;

        if(title === '')
        {
            setTitleerror(true)
            error =1;
        }
        if(expires_on === '')
        {
            setExpriresnerror(true)
            error = 1;
            
        }
        if(job_category_id === '')
        {
            setJobcat(true)
            error = 1;
            
        }
       
        let token = "Bearer "+localStorage.getItem('token');
        console.log(token)
        const data = {
            title :title,
            description :description,
            expires_on:moment(expires_on).format('MM-DD-YYYY'),
            contact_name:contact_name,
            contact_email:contact_email,
            job_category_id,job_category_id,
            school_id:school_id,
            status :'ACTIVE'
        }
        //console.log('all datas',data)
        const instance = axios.create({

            baseURL: schoolJobsurl+'/'+school_id,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.post('',data).then((response) =>{

            console.log(response.data)
            
            let path = 'newPath'; 
            navigate("/jobs/"+id)
           
          }).catch((error) =>{
            
            //console.log('error',error.message)

            //setNameerror('Enter the Name')
            

          });



    }

    

    return(
        <div className="wrapper">
            <aside className="right-side ">
            <div className="content-area">
                <div className="page-title-wrpr">
                    <div className="page-title-left-column">                
                    <h2 className="page-title">Add Jobs</h2>
                </div>
                <div className="page-rightside-action-column">
               </div>
            </div>        
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li className="breadcrumb-item"><Link to={"/jobs/"+id}>Jobs</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Add Jobs</li>
              </ol>
            </nav>
            <div className="form-wrpr">
                <div className="card formcard small">
                    <div className="card-body">
                        <div className="form-group">
                            <label className="degreehead">Enter the job title <span style={{color: "red"}}>*</span></label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" value={title} onChange={e => {setTitle(e.target.value)}} placeholder="Enter The Title" id="name"></input>
                            {
                                titleerror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Title</div>
                                :null
                            }
                        </div>
                        <div className="form-group">
                            <label className="degreehead">Description</label>
                            <RichTextEditor className="Desc-RTE" value={description} onChange={descriprionset} />
                            
                        </div>
                        <div className="form-group">
                            <label className="degreehead">Expires ON <span style={{color: "red"}}>*</span></label>
                            {/* <input type="date" className="form-control bg-dark dark-theme showtext" value={expires_on} onChange={e => {setExpires_on(e.target.value)}} id="name"></input> */}
                            <DatePicker
                                className="form-control justshow bg-dark"
                                selected={expires_on}
                                onChange={(date) => setExpires_on(date)}
                                value={expires_on}
                                isClearable
                                placeholderText="Enter Expires ON (MM/DD/YYYY)"
                                showMonthDropdown={true}
                                showYearDropdown={true}
                                scrollableYearDropdown={false}
                                filterDate = {(date) => {
                                    return moment() <= date;
                                }}
                            />
                            {
                                expriresnerror
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Expire Date</div>
                                :null
                            }
                        </div>

                        <div className="form-group">
                            <label className="degreehead">Contact Name</label>
                            <input type="text" placeholder="Enter Contact Name" className="form-control bg-dark dark-theme showtext" value={contact_name} onChange={e => {setContact_name(e.target.value)}} id="name"></input>
                        </div>

                        <div className="form-group">
                            <label className="degreehead">Contact Email</label>
                            <input type="text" placeholder="Enter Email" className="form-control bg-dark dark-theme showtext" value={contact_email} onChange={e => {setContact_email(e.target.value)}} id="name"></input>
                        </div>
                        
                        <div className="form-group">
                            <label className="degreehead">Job Category <span style={{color: "red"}}>*</span></label>
                            <select className="form-control bg-dark dark-theme showtext" onChange={e => {setJob_category_id(e.target.value)}} id="status-selector">
                                <option value="0">Select Job Category</option>
                                {
                                    result?.map((item,index)=>(
                                        
                                        <option key={index} value={item.id}>{item.name}</option>
                                        
                                    )
                                    
                                    )
                                }
                             
                            </select>
                            {
                                jobcat
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Select The Job Category</div>
                                :null
                            }
                        </div>

                        {/* <div className="form-group">
                            <label className="degreehead">Status</label>
                            <select onChange={e => {setStatus(e.target.value)}} className="form-control bg-dark dark-theme showtext" id="status-selector">
                              <option value="ACTIVE">Select Status</option>
                              <option value="ACTIVE">ACTIVE</option>
                              <option value="INACTIVE">INACTIVE</option>
                              <option value="DELETED">DELETED</option>
                            </select>
                        </div> */}



                            
                        <div className="form-group text-right">
                        <button className="btn btn-danger btn-gisa" onClick={()=> { RoutToList(id)} } type="submit">Cancel</button>
                            <button onClick={()=> { OnFormClick(id) }} className="btn btn-primary btn-gisa" type="button">Create</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            </aside>
        </div>
    )
}

export default AddJobComponent;
